import { IconPrinter } from "@tabler/icons-react"
import { DateTime } from "../../../../../@client/System"
import { ResponsiveActionIconButton } from "./responsive-action-icon-button"

interface Props {
  departmentId: number
  start: DateTime
  end: DateTime
  filteredWorkareaIds: number[] | null | undefined
  productionId: number | null | undefined
  disabled: boolean
}

function toQueryParameter(filteredWorkareaIds: number[] | null | undefined) {
  return filteredWorkareaIds === null ||
    filteredWorkareaIds === undefined ||
    filteredWorkareaIds.length === 0
    ? ""
    : "" + filteredWorkareaIds.map((v) => `&workareaIds=${v}`).join("")
}

export function PrintCastButton({
  departmentId,
  start,
  end,
  productionId,
  filteredWorkareaIds,
  disabled,
}: Props) {
  const workareasParameter = toQueryParameter(filteredWorkareaIds)
  const url = `/api/orchestra/GetPrintCast?departmentId=${departmentId}&start=${start}&end=${end}${workareasParameter}${productionId ? `&productionId=${productionId}` : ""}`

  return (
    <ResponsiveActionIconButton
      icon={<IconPrinter size={16} />}
      buttonProps={{
        size: "xs",
        variant: "default",
        children: "PDF",
        onClick: () => {
          window.open(url, "_blank")
        },
        disabled,
      }}
      actionIconProps={{
        variant: "default",
        onClick: () => {
          window.open(url, "_blank")
        },
        disabled,
      }}
    />
  )
}
